import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import './StatusIcon.css';

/** A compact, accessible visual indicator for boolean active states. */
export default function StatusIcon({ active, className = '' }) {
  const label = active ? 'Active' : 'Inactive';
  const Icon = active ? CheckCircleOutlineOutlinedIcon : CancelOutlinedIcon;

  return (
    <span
      className={`status-icon ${active ? 'status-icon--active' : 'status-icon--inactive'} ${className}`}
      role="img"
      aria-label={label}
      title={label}
    >
      <Icon fontSize="small" aria-hidden="true" />
    </span>
  );
}
